module.exports = ".test-page{\n\ttext-align: center;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n}\n\n.test-page h1{\n\tposition: relative;\n    -webkit-transform: translate(0%,-25%);\n            transform: translate(0%,-25%);\n    width: 100%;\n    left: 0%;\n    top: 25%;\n    font-weight: bold;\n    color: #1427e6;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/test/test-page/test-page.component.css
// module id = ./src/app/test/test-page/test-page.component.css
// module chunks = main